<ion-content [fullscreen]="true" class="soft-background">
  <modal-container [breadcrumbsList]="breadcrumbsList" [hideSaveButton]="true">
    <div class="monitoring-header-clean">
      <ion-segment value="new" [value]="currentSegment" mode="ios" class="clean-segment">
        <ion-segment-button value="new" content-id="new">
          <ion-label>Nuova Segnalazione</ion-label>
        </ion-segment-button>
        <ion-segment-button value="history" content-id="history">
          <ion-label>I miei Ticket</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <div class="content-container">
      <ion-segment-view class="segment-view-container">

        <ion-segment-content id="new">
          <div class="soft-card form-card">
            <h3 class="card-title">Come possiamo aiutarti?</h3>
            <p class="card-subtitle">Descrivi il problema riscontrato nel portale.</p>

            <form [formGroup]="ticketForm" (ngSubmit)="submitTicket()">

              <div class="select-wrapper">
                <div>
                  <label>Categoria</label>
                  <mat-form-field appearance="outline" class="soft-mat-field">
                    <mat-select formControlName="category" placeholder="Seleziona categoria">
                      <mat-option value="bug">Errore</mat-option>
                      <mat-option value="feature">Richiesta Nuova Funzione</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="soft-input-wrapper">
                <label>Oggetto</label>
                <input type="text" formControlName="summary" class="soft-native-input"
                  placeholder="Es. Errore caricamento stanze">
              </div>

              <div class="soft-input-wrapper">
                <label>Descrizione Dettagliata</label>
                <textarea rows="5" formControlName="description" class="soft-native-input area"
                  placeholder="Spiega cosa è successo..."></textarea>
              </div>

              <input #attachmentInput type="file"
                accept="image/*,.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                class="file-input" (change)="onAttachmentSelected($event)">
              <button type="button" class="upload-box" [class.dragging]="isDragging"
                [attr.aria-describedby]="attachmentError ? 'attachment-formats attachment-error' : 'attachment-formats'"
                (click)="attachmentInput.click()" (dragenter)="onDragOver($event)" (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)" (drop)="onAttachmentDropped($event)">
                <mat-icon>{{ selectedFile ? 'description' : 'cloud_upload' }}</mat-icon>
                <span class="upload-title">
                  {{ selectedFile ? selectedFile.name : 'Allega documentazione (opzionale)' }}
                </span>
                <span class="upload-hint">
                  {{ selectedFile ? 'Clicca o trascina un altro file per sostituirlo' : 'Trascina qui oppure clicca per selezionare' }}
                </span>
                <span id="attachment-formats" class="upload-formats">Immagini, PDF o Word (.doc, .docx)</span>
              </button>
              <p *ngIf="attachmentError" id="attachment-error" class="upload-error" aria-live="polite">
                {{ attachmentError }}
              </p>

              <ion-button expand="block" mode="md" class="submit-btn" type="submit"
                [disabled]="ticketForm.invalid || isSubmitting">
                <span *ngIf="!isSubmitting">Invia Segnalazione</span>
                <ion-spinner *ngIf="isSubmitting" name="crescent"></ion-spinner>
              </ion-button>

            </form>
          </div>
        </ion-segment-content>

        <ion-segment-content id="history">

          <div *ngIf="ticketsList.length; else emptyHistory">
            <div *ngFor="let ticket of ticketsList" class="ticket-card">
              <div class="ticket-status-line" [style.background]="getStatusColor(ticket.status)"></div>
              <div class="ticket-content">
                <div class="ticket-header">
                  <span class="ticket-id">{{ticket.key}}</span>
                  <span class="ticket-date">{{ticket.created | date:'dd/MM/yyyy'}}</span>
                </div>
                <h4 class="ticket-subject">{{ticket.summary}}</h4>
                <div class="ticket-footer">
                  <span class="status-badge" [style.color]="getStatusColor(ticket.status)"
                    [style.background]="getStatusColor(ticket.status) + '20'">
                    {{ticket.status}}
                  </span>
                  <mat-icon>chevron_right</mat-icon>
                </div>
              </div>
            </div>
          </div>

          <ng-template #emptyHistory>
            <div class="empty-state">
              <div class="empty-icon-bg">
                <mat-icon>confirmation_number</mat-icon>
              </div>
              <h3>Nessun ticket presente</h3>
              <p>Non hai ancora inviato segnalazioni.</p>
            </div>
          </ng-template>

        </ion-segment-content>
      </ion-segment-view>
    </div>
  </modal-container>
</ion-content>
